import moment from 'moment-timezone'

const HexAndRbga = require('hex-and-rgba')
const platform = require('platform')

export const GOOGLE_MAP_API_KEY = 'AIzaSyAYyMsf2RYGCnA48OwrWtZL_IOOryXGDEo'
export const GOOGLE_MAP_VECTOR_MAP_ID = 'e44157224692cfe3'

export const DEFAULT_MAP_SIZE = 140

export const MAP_STYLE_BRIGHT = 'bright'
export const MAP_STYLE_SATELLITE = 'satellite'

export const GTAG_TRACKING_ID = {
  production: 'G-NZC4W5PX12',
  development: 'G-T687BPSQR9',
}
export const OPEN_WEATHER_MAP_KEY = '5aa0557097d39bf7b2ff34a7d1be35a7'

export const SHOPIFY_SSO_KEY = '83e288f65313048fa965206f75a7c15c'

const DEVICE_VALUE_MAX_LENGTH = 20
const UNKNON = 'UNKNOWN'

export const DEVICE_ID = platform.description ? platform.description.substring(0, DEVICE_VALUE_MAX_LENGTH) : UNKNON
export const DEVICE_MANUFACTURER = platform.os ? platform.os.toString().substring(0, DEVICE_VALUE_MAX_LENGTH) : UNKNON
export const DEVICE_MODEL = platform.name ? platform.name.substring(0, DEVICE_VALUE_MAX_LENGTH) : UNKNON
export const DEVICE_SYSTEM_VERSION = platform.version ? platform.version.substring(0, DEVICE_VALUE_MAX_LENGTH) : UNKNON

export const LANG_DE = 'de'
export const LANG_EN = 'en'
export const LANG_ES = 'es'
export const LANG_JA = 'ja'
export const LANG_PT = 'pt'
export const LANG_PL = 'pl'
export const LANG_RU = 'ru'
export const LANG_TH = 'th'
export const LANG_PT_BR = 'pt-BR'
export const LANG_ES_LATIN = 'es-419'
export const LANG_DEFAULT = 'en'

export const LOGOUT_URLS = {
  de: 'https://agri-info-design.com/en/agribus-web/',
  en: 'https://agri-info-design.com/en/agribus-web/',
  es: 'https://agri-info-design.com/es/agribus-web/',
  ja: 'https://agri-info-design.com/agribus-web/',
  pt: 'https://agri-info-design.com/pt-br/agribus-web/',
  pl: 'https://agri-info-design.com/pl/agribus-web/',
  ru: 'https://agri-info-design.com/ru/agribus-web/',
  th: 'https://agri-info-design.com/th/agribus-web/',
}

export const DATE_PICKER_FORMAT_DE = 'yyyy-MM-dd'
export const DATE_PICKER_FORMAT_EN = 'dd MMM yyyy'
export const DATE_PICKER_FORMAT_JA = 'yyyy/MM/dd'
export const DATE_PICKER_FORMAT_ES = 'dd-MM-yyyy'
export const DATE_PICKER_FORMAT_PT = 'yyyy/MM/dd'
export const DATE_PICKER_FORMAT_PL = 'yyyy-MM-dd'
export const DATE_PICKER_FORMAT_RU = 'dd/MM/yyyy'
export const DATE_PICKER_FORMAT_TH = 'dd/MM/yyyy'

export const DATE_MOMENT_FORMAT_DE = 'YYYY-MM-DD'
export const DATE_MOMENT_FORMAT_EN = 'DD MMM YYYY'
export const DATE_MOMENT_FORMAT_JA = 'YYYY/MM/DD'
export const DATE_MOMENT_FORMAT_ES = 'DD-MM-YYYY'
export const DATE_MOMENT_FORMAT_PT = 'DD/MM/YYYY'
export const DATE_MOMENT_FORMAT_PL = 'YYYY-MM-DD'
export const DATE_MOMENT_FORMAT_RU = 'DD/MM/YYYY'
export const DATE_MOMENT_FORMAT_TH = 'DD/MM/YYYY'

export const DATE_MOMENT_MONTH_FORMAT_DE = 'MM-YYYY'
export const DATE_MOMENT_MONTH_FORMAT_EN = 'MMM YYYY'
export const DATE_MOMENT_MONTH_FORMAT_JA = 'YYYY年MM月'
export const DATE_MOMENT_MONTH_FORMAT_ES = 'MM-YYYY'
export const DATE_MOMENT_MONTH_FORMAT_PT = 'MM/YYYY'
export const DATE_MOMENT_MONTH_FORMAT_PL = 'MM-YYYY'
export const DATE_MOMENT_MONTH_FORMAT_RU = 'MM/YYYY'
export const DATE_MOMENT_MONTH_FORMAT_TH = 'MM/YYYY'

/** Freeプランでの履歴保管期間（２日） */
export const HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_FREE_PLAN = 2 * 24

/** Standardプランでの履歴保管期間（１年半） */
export const HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_STANDARD_PLAN = (365 * 24 * 3) / 2

export const DEFAULT_TIMEZONE = moment.tz.guess()

export const EVENT_SET_MAP_MARKER = 'setMapMarker'
export const EVENT_SHOW_REALTIME_POINT = 'showRealtimePoint'
export const EVENT_SHOW_LATEST_TRACK = 'showLatestTrack'

// FIXME colorの定義をSASSと共有するには？
export const CONNECT_GREEN = '#00A26A'

export const FIELD_FILL_COLOR = CONNECT_GREEN
export const FIELD_FILL_OPACITY = 0.6

const fieldFillColorRgba = HexAndRbga.hexToRgba(FIELD_FILL_COLOR)

export const FILED_FILL_COLOR_RGBA = HexAndRbga.hexToRgba(
  fieldFillColorRgba[0],
  fieldFillColorRgba[1],
  fieldFillColorRgba[2],
  FIELD_FILL_OPACITY
)
export const FIELD_CURRENT_LINE_COLOR = '#de3529'
export const MY_FILED_CURRENT_THUMBNAIL_LINE_COLOR = '0xde3529'
export const OTHERS_FILED_CURRENT_THUMBNAIL_LINE_COLOR = '0x000000'
export const MY_FIELD_THUMBNAIL_FILL_COLOR = '0x00A26A'
export const OTHERS_FIELD_THUMBNAIL_FILL_COLOR = '0xBBB3B8'
export const FIELD_CURRENT_LINE_WIDTH = 4
export const FIELD_LINE_WIDTH = 2

export const FIELD_FILL_COLOR_ANOTHER_PERSON = '#BBB3B8'

export const CREATE_FIELD_FILL_COLOR = FIELD_FILL_COLOR
export const CREATE_FIELD_FILL_OPACITY = FIELD_FILL_OPACITY
export const CREATE_FIELD_LINE_COLOR = FIELD_CURRENT_LINE_COLOR
export const CREATE_FIELD_LINE_WIDTH = FIELD_CURRENT_LINE_WIDTH
export const CREATE_FIELD_VERTEX_COLOR = FIELD_CURRENT_LINE_COLOR
export const CREATE_FIELD_VERTEX_SIZE = 3
export const CREATE_FIELD_VERTEX_HALOS_COLOR = '#FFF'
export const CREATE_FIELD_VERTEX_HALOS_SIZE = 5

export const FIELD_CARD_THUMBNAIL_SIZE = 190

export const DEFAULT_WORK_WIDTH = 5

export const TRACK_COLORS_ALTITUDE = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#f44336']
export const TRACK_COLORS_SPEED = ['#e8eaf6', '#c5cae9', '#9fa8da', '#7986cb', '#3f51b5']
export const TRACK_COLORS_GNSS_NUM_OF_SATELITES = ['#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ff9800']
export const TRACK_COLORS_GNSS_STATUS = ['#f3e5f5', '#e1bee7', '#ce93d8', '#ba68c8', '#9c27b0']
export const TRACK_COLORS_GUIDANCE_ERROR = ['#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#8bc34a']
export const TRACK_COLORS_GUIDANCE_HEADING_ERROR = ['#e1f5fe', '#b3e5fc', '#81d4fa', '#4fc3f7', '#03a9f4']
export const TRACK_COLORS_SLANT = ['#fce4ec', '#f8bbd0', '#f48fb1', '#f06292', '#e91e63']
export const TRACK_COLORS = ['#009eff', '#44f8ff', '#00ff38', '#f0ff00', '#ff6f6f']
export const TRACK_COLOR_CODED_FILL_COLORS = ['#FFFFC0', '#EBA3F1', '#B4F4AA', '#D9D9FF']
export const TRACK_FILL_COLOR = '#d8c477'
export const TRACK_FILL_OPACITY = 0.7

export const CHART_ALTITUDE_COLOR = '#2ad98a'
export const CHART_SPEED_COLOR = '#44f8ff'

export const CROP_DEFAULT_COLOR = '#4CAF50'
export const CROP_COLORS = [
  '#f44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#2196F3',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#795548',
  '#9E9E9E',
  '#607D8B',
  '#EEEEEE',
]

export const OperationTypeColor = {
  Tilling: {
    backgroundColor: '#373018',
    color: '#ffffff',
  },
  Sowing: {
    backgroundColor: '#3c10d6',
    color: '#f0f0f0',
  },
  Planting: {
    backgroundColor: '#38c341',
    color: '#000000',
  },
  Fertilizing: {
    backgroundColor: '#d8602d',
    color: '#ebebeb',
  },
  CropProtection: {
    backgroundColor: '#bff8fa',
    color: '#000000',
  },
  Harvesting: {
    backgroundColor: '#f1e604',
    color: '#000000',
  },
  Other: {
    backgroundColor: '#f4ebf0',
    color: '#000000',
  },
}

export const KEY_LOGIN_REMEMBER_ME = 'loginRememberMe'
export const KEY_REFRESH_TOKEN = 'refreshToken'
export const KEY_USER_INFO = 'userInfo'
export const KEY_REFRESH_TOKEN_EXPIRED_AT = 'refreshTokenExpiredAt'
export const USER_LANG_KEY = 'userLang'
export const KEY_PURCHASE_INFO = 'purchaseInfo'

export const PASSWORD_MIN_LENGTH_ON_COGNITO = 8
export const PASSWORD_MAX_LENGTH_ON_COGNITO = 60

export const UTC_FORMAT_DEFAULT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
export const SEC_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const JST_FORMAT = 'uuuu/MM/dd HH:mm:ss'

export const MANAGER_SERVER_LOCAL = 'http://localhost:8080'
export const MANAGER_SERVER_DEV = 'https://manager-development.agribus-connect.net'
export const MANAGER_SERVER_PROD = 'https://manager.agribus-connect.net'

export const SERVER_URL_REGION_MARK = '{region}'
export const NAVI_SERVER_LOCAL = 'http://localhost:8081'
export const NAVI_SERVER_DEV = 'https://navi-development.agribus-connect.net'
export const NAVI_SERVER_DEVFIRE = 'https://navi-development-fire.agribus-connect.net'
export const NAVI_SERVER_PROD = `https://navi-${SERVER_URL_REGION_MARK}.agribus-connect.net`

export const ENTERPRISE_SERVER_LOCAL = 'http://localhost:8082'
export const ENTERPRISE_SERVER_DEV = 'https://enterprise-development.agribus-connect.net'
export const ENTERPRISE_SERVER_PROD = 'https://enterprise.agribus-connect.net'

export const GROW_SERVER_LOCAL = 'http://localhost:8084'
export const GROW_SERVER_DEV = 'https://grow-development.agribus-connect.net'
export const GROW_SERVER_PROD = 'https://grow.agribus-connect.net'

export const DATASTORE_SERVER_LOCAL = 'http://localhost:8085'
export const DATASTORE_SERVER_DEV = 'https://datastore-development.agribus-connect.net'
export const DATASTORE_SERVER_PROD = 'https://datastore.agribus-connect.net'

export const AUTH_SERVER_LOCAL = 'http://localhost:8086'
export const AUTH_SERVER_DEV = 'https://auth-development.agribus-connect.net'
export const AUTH_SERVER_PROD = 'https://auth.agribus-connect.net'

export const PAY_SERVER_LOCAL = 'http://localhost:8087'
export const PAY_SERVER_DEV = 'https://pay-development.agribus-connect.net'
export const PAY_SERVER_PROD = 'https://pay.agribus-connect.net'

export const MAP_TASK_COLORED_MODE_NONE = 'none'
export const MAP_TASK_COLORED_MODE_ALTITUDE = 'altitude'
export const MAP_TASK_COLORED_MODE_SPEED = 'speed'
export const MAP_TASK_COLORED_MODE_GNSS_NUM_OF_SATELLITES = 'gnssNumOfSatellites'
export const MAP_TASK_COLORED_MODE_GNSS_STATUS = 'gnssStatus'
export const MAP_TASK_COLORED_MODE_GUIDANCE_ERROR = 'guidanceError'
export const MAP_TASK_COLORED_MODE_GUIDANCE_HEADING_ERROR = 'guidanceHeadingError'
export const MAP_TASK_COLORED_MODE_SLANT = 'slant'
export const MAP_TASK_COLORED_MODE_COLOR_CODED = 'colorCoded'

export const TASK_DIVIDED_LEVEL_COUNT = 5

export const GeoJsonProp = {
  POLYGON_ALL: 'polygon-all',
  POINT_ALL: 'point-all',
  POLYGON_ALTITUDE_PREFIX: 'polygon-altitude-',
  POLYGON_SPEED_PREFIX: 'polygon-speed-',
  POLYGON_GNSS_NUM_OF_SATELLITES_PREFIX: 'polygon-gnss-num-of-satellites-',
  POLYGON_GNSS_STATUS_PREFIX: 'polygon-gnss-status-',
  POLYGON_GUIDANCE_ERROR_PREFIX: 'polygon-guidance-error-',
  POLYGON_GUIDANCE_HEADING_ERROR_PREFIX: 'polygon-guidance-heading-error-',
  POLYGON_SLANT_PREFIX: 'polygon-slant-',
  POLYGON_FILL_COLOR_PREFIX: 'polygon-fill-color-',
  POINTS_ALL_ALTITUDES: 'points-all-altitudes',
  POINTS_ALL_SPEEDS: 'points-all-speeds',
  POINTS_ALL_CREATED_DATE_TIME: 'points-all-created-date-time',
  POINTS_ALL_GNSS_NUM_OF_SATELLITES: 'points-all-gnss-num-of-satellites',
  POINTS_ALL_GNSS_STATUS: 'points-all-gnss-status',
  POINTS_ALL_GUIDANCE_ERROR: 'points-all-guidance-error',
  POINTS_ALL_GUIDANCE_HEADING_ERROR: 'points-all-guidance-heading-error',
  POINTS_ALL_SLANT: 'points-all-slant',
}

export const MAP_VISIBILITY = 'visibility'
export const MAP_VISIBLE = 'visible'
export const MAP_NONE = 'none'

export const ICON_DEFAULT = 'Default'
export const DEFAULT_ICON_URL = '/icons/ic_person_black_48dp.png'

export const ICON_PRESET_1 = 'Preset1'
export const ICON_PRESET_1_URL = '/icons/ic_preset_1.png'

export const ICON_PRESET_2 = 'Preset2'
export const ICON_PRESET_2_URL = '/icons/ic_preset_2.png'

export const ICON_PRESET_3 = 'Preset3'
export const ICON_PRESET_3_URL = '/icons/ic_preset_3.png'

export const ICON_PRESET_4 = 'Preset4'
export const ICON_PRESET_4_URL = '/icons/ic_preset_4.png'

export const ICON_PRESET_5 = 'Preset5'
export const ICON_PRESET_5_URL = '/icons/ic_preset_5.png'

export const ICON_PRESET_6 = 'Preset6'
export const ICON_PRESET_6_URL = '/icons/ic_preset_6.png'

export const ICON_GRAVATAR = 'Gravatar'
export const ICON_CUSTOM = 'Custom'

export const DEFAULT_LIST_PAGE_SIZE = 20

/** @deprecated */
export const TASK_LIST_LISTING_USER_ALL = 'all'
/** @deprecated */
export const TASK_LIST_LISTING_USER_SELF = 'self'

export const LIST_VIEW_MODE_APPEND = 'append'
export const LIST_VIEW_MODE_LIST = 'list'
export const LIST_VIEW_MODE_CARD = 'card'
export const LIST_VIEW_MODE_CALENDAR = 'calendar'

export const CALENDAR_MAX_TASK_COUNT_IN_DATE = 4

export const STORAGE_CACHE_KEY_PREFIX = 'cache-'

/** 独自Storage CacheのExpire Seconds（1時間） */
export const STORAGE_CACHE_DEFAULT_EXPIRE_SECONDS = 60 * 60

export const MQTT_TOPIC_PATH_PREFIX = 'navi/geo_point/'

export const INIT_FIELD_OPTION_SHOW_FIELD_IMPORT = 'showFieldImport'
export const SHOW_TASK_DETAIL_FROM_DIRECT = 'showTaskDetailFromDirect'
export const SHOW_TASK_DETAIL_FROM_LIST = 'showTaskDetailFromList'

export const TASK_ARCHIVE_DIALOG_STEP_SELECT_FORMAT = 0
export const TASK_ARCHIVE_DIALOG_STEP_DOWNLOADING = 1
export const TASK_ARCHIVE_DIALOG_STEP_FINISHED = 100

export const CONNECT_ENV_PROD_NAME = 'prod'
export const CONNECT_ENV_LOCAL_NAME = 'local'
export const CONNECT_ENV_DEV_NAME = 'dev'
export const CONNECT_ENV_DEVFIRE_NAME = 'devfire'

export const REFRESH_TOKEN_INTERVAL = 10 * 60 * 1000 // 10分
export const TOAST_DISMISS_INTERVAL = 8 * 1000 // 8秒

export const TRACTOR_ICON_URLS = [
  '/images/tractor.green.32.png',
  '/images/tractor.red.32.png',
  '/images/tractor.yellow.32.png',
]

export const NOW_ACTIVE_CHECK_INTERVAL_SECONDS = 20 * 1000 // 20秒
export const NOW_TRACK_OPACITY = 0.3

export const TASK_FILTER_ENDPOINT_DEV = 'https://t28fl6a98a.execute-api.us-west-1.amazonaws.com/Prod/taskfilter/'
export const TASK_FILTER_ENDPOINT_PROD = 'https://aipd3eep93.execute-api.us-west-2.amazonaws.com/Prod/taskfilter/'
export const TASK_FILTER_DEFAULT_FLG_ENDPOINT = 'defaultflg'
export const TASK_FILTER_GET_MODE = {
  FIRST_PROCESS: 1,
  CREATE: 2,
  DELETE: 4,
}

export const RESPONSIVE_BREAKPOINT_FIELD_LIST = 650
export const TASKS_PAGINATION_INFO_TYPE = 'tasks'
export const CURRENT_FIELD_TASKS_PAGINATION_INFO_TYPE = 'currentFieldTasks'
export const FIELDS_PAGINATION_INFO_TYPE = 'fields'
export const REFLINES_PAGINATION_INFO_TYPE = 'refLines'

export const DATE_PICKER_TYPE_MONTH = 'month'
export const RESPONSIVE_BREAKPOINT_TASK_LIST = 1000
export const RESPONSIVE_BREAKPOINT_MD_SIZE = 960
export const RESPONSIVE_BREAKPOINT_USER_ICON = 650

/* ユーザプール localdevを使う場合はこれを使う（connect-managerのidp設定も変える）
export const GOOGLE_OAUTH_DOMAIN_LOCAL = 'agribus-web-test'
export const GOOGLE_OAUTH_RESION_LOCAL = 'us-east-1'
export const COGNITO_CLIENT_ID_LOCAL = '4283e36jbsk2rieg5hmcgq8rd0'
export const GOOGLE_OAUTH_REDIRECT_URL_LOCAL = 'http://localhost:4200/OAuthCallback'
*/
export const GOOGLE_OAUTH_DOMAIN_LOCAL = 'agribus-web-dev'
export const GOOGLE_OAUTH_RESION_LOCAL = 'us-east-1'
export const COGNITO_CLIENT_ID_LOCAL = '6hdjbd5k1i828iljnodiuuj8lf'
export const GOOGLE_OAUTH_REDIRECT_URL_LOCAL = 'http://localhost:4200/oauth_callback'

export const GOOGLE_OAUTH_DOMAIN_DEV = 'agribus-web-dev'
export const GOOGLE_OAUTH_RESION_DEV = 'us-east-1'
export const COGNITO_CLIENT_ID_DEV = '6hdjbd5k1i828iljnodiuuj8lf'
export const GOOGLE_OAUTH_REDIRECT_URL_DEV = 'https://dev.agribus-connect.com/oauth_callback'
export const GOOGLE_OAUTH_REDIRECT_SSO_URL_DEV = 'https://dev.agribus-connect.com/oauth_callback/sso'

export const GOOGLE_OAUTH_DOMAIN_PROD = 'oauth.agribus-connect.com'
export const GOOGLE_OAUTH_RESION_PROD = 'us-west-2'
export const COGNITO_CLIENT_ID_PROD = '24ql61fii34aho9re425e4g8e2'
export const GOOGLE_OAUTH_REDIRECT_URL_PROD = 'https://app.agribus-connect.com/oauth_callback'
export const GOOGLE_OAUTH_REDIRECT_SSO_URL_PROD = 'https://app.agribus-connect.com/oauth_callback/sso'

export const SHOPIFY_DOMAIN = 'shop.agri-info-design.com'
export const SHOPIFY_URL = 'https://' + SHOPIFY_DOMAIN + '/'

// AgriBus-DWH マーケット情報 (soybean/wheat monitor, Cloud Run)
export const SOYBEAN_MONITOR_URL = 'https://soybean-monitor-xng3av2ruq-uc.a.run.app'
export const WHEAT_MONITOR_URL = 'https://wheat-monitor-xng3av2ruq-uc.a.run.app'
export const FEED_API_URL = 'https://feed-api-551054685597.us-central1.run.app'

export const PermissionPreset = {
  READ_ONLY_SUBSCRIPTION: 'read_only_subscription',
}
export const STANDARD_PLAN = 'Standard'
export const ENTERPRISE_PLAN = 'Enterprise'
export const PLUS_PLAN = 'Plus'
export const PROFESSIONAL_PLAN = 'Professional'

export const StripeCollectionMethod = {
  ChargeAutomatically: 'charge_automatically',
  SendInvoice: 'send_invoice',
}

export const EXPORT_MODE = {
  TASK_RECORDS: 1,
  REFLINES: 2,
}

export const IMPORT_MODE = {
  FIELDS: 1,
  REFLINES: 2,
}

export const REFLINE_COLOR = '#F44336'

export const RefLineTypes = {
  Straight: 'Straight',
  Curved: 'Curved',
}

/** 作成できる観測点の最大数 */
export const MaxObservationCount = {
  PF: { AsFree: 1, AsStandard: 5, AsProfessional: 5, AsPlus: 5 },
  AT: { AsFree: 1, AsStandard: 5, AsProfessional: 5, AsPlus: 5 },
}

/** 積算温度の下限値のデフォルト */
export const DEFAULT_LOWER_LIMIT_TEMPERATURE_FOR_ACCUMULATED = 5
/** 積算温度を計算する期間の最大日数 */
export const MAX_DAYS_COUNT_FOR_ACCUMULATED_TEMPERATURE = 300

export const GROW_API_KEY_LOCAL = 'aid'
export const GROW_API_KEY_DEV = 'aid'
export const GROW_API_KEY_PROD = 'ziERXMrBwBwCZNvh7ejEDjmHGhVcFRhzAzTe7LbC6K89Up9Vd3kcYCg3c44RPKsV'

export const GeoFeaturePropertiesType = {
  ID: 'id',
  PK: 'pk',
  TYPE: 'type',
  FIELD: 'field',
  BASE: 'base',
  BLUE: 'blue',
  RED: 'red',
}

export const StripePlanPeriod = {
  MONTH: 'month',
  YEAR: 'year',
}

// Casterの基地局、移動局のリスト取得をする頻度（CasterInfo.vue）
export const LIST_CASTER_BASES_AND_ROVERS_INTERVAL_SECONDS = 30

// Casterの補正情報統計 (現在値) の取得頻度（CasterInfo.vue）
export const CASTER_STATS_INTERVAL_SECONDS = 15
// Casterの補正情報統計 (1分集計履歴) と移動局軌跡の取得頻度（CasterInfo.vue）
export const CASTER_STATS_HISTORY_INTERVAL_SECONDS = 60
// 品質グラフに表示する履歴の長さ (分)
export const CASTER_STATS_HISTORY_MINUTES = 180

export const APIErrorCode = {
  MULTIPOLYGON_IMPORT_ERROR: 'MPI-852195836',
}

export const SortDirection = {
  ASC: 'Asc',
  DESC: 'Desc',
}

export const SortOrder = {
  Field: {
    Name: { keyName: 'Name', direction: SortDirection.ASC, textValue: 'sortOptions.field.name' },
    CreatedAt: {
      keyName: 'CreatedAt',
      direction: SortDirection.DESC,
      textValue: 'sortOptions.field.createdAt',
    },
    // LastModifiedDateTimeは未使用
    LastModifiedDateTime: {
      keyName: 'lastModifiedDateTime',
      direction: SortDirection.DESC,
      textValue: 'sortOptions.field.lastModifiedDateTime',
    },
  },
}

export const FieldElevationMap = {
  DEFAULT_MESH_SIZE: 3,
  DEFAULT_TASK_FETCH_LIMIT: 3,
  GNSS_STATUS_FILTERS: [
    { text: 'RTK Fix', value: 'VeryStrict' },
    { text: 'RTK Fix/Float', value: 'Strict' },
    { text: 'RTK Fix/Float, DGNSS', value: 'Loose' },
    { text: 'Any', value: 'VeryLoose' },
  ],
  DEFAULT_GNSS_STATUS_FILTER_VALUE: 'VeryStrict',
}

export const FireTestApiKey = {
  Compare: {
    prod: 'Z6clG0a8nRI1QABXZhUmkflRtke47j8s',
    dev: 'usDnVg2GLq16SiFrJdJo4yFqptIeGhlY',
  },
  Data: {
    prod: 'sC4zJzyGdC6vCuNbhwyPcPZU53XVZ4NKFa7W',
    dev: 'T9G3kgSrWzWY9YaJqxWiQTvD',
    local: 'fire',
  },
}

export const SYNC_WAIT_LIMIT_COUNT = 10
export const SYNC_WAIT_API_CALL_INTERVAL = 1000

// 圃場作成・インポート後の一覧再取得間隔 (秒)。Firestore→RDB 同期関数の
// コールドスタートで 10 秒以上かかることがあるため、合計 ~60 秒まで粘る
export const SYNC_RELOAD_DELAYS_SEC = [1, 1, 2, 2, 3, 3, 5, 5, 8, 10, 10, 10]

export const IMPORT_LIMIT = {
  FIELDS: 500,
  REFLINES: 500,
}
